import React, { Fragment, useState, useEffect } from "react";
import { Button, Dropdown, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { getProfile, updateProfile, reset } from '../../features/profile/profileSlice'



//** Import Image */
import profile01 from "../../images/profile/1.jpg";
import profile02 from "../../images/profile/2.jpg";
import profile03 from "../../images/profile/3.jpg";
import profile04 from "../../images/profile/4.jpg";
import profile05 from "../../images/profile/5.jpg";
import profile06 from "../../images/profile/6.jpg";
import profile07 from "../../images/profile/7.jpg";
import profile08 from "../../images/profile/8.jpg";
import profile09 from "../../images/profile/9.jpg";
import profile from "../../images/profile/profile.png";

const Profile = () => {
	let { profileId } = useParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const isAuthenticated = useSelector((state) => state.auth.user !== null);
	const { profile, isSuccess, isError, message } = useSelector((state) => state.profile);
	const safeProfile = profile || {};


	const [activeToggle, setActiveToggle] = useState("posts");
	const [sendMessage, setSendMessage] = useState(false);
	const [postModal, setPostModal] = useState(false);
	const [cameraModal, setCameraModal] = useState(false);
	const [linkModal, setLinkModal] = useState(false);
	const [replayModal, setReplayModal] = useState(false);
	const options = {
		settings: {
			overlayColor: "#000000",
		},
	};

	useEffect(() => {
		if (!isAuthenticated) { navigate('/login') }
		if (isError) { console.log(message); }
		dispatch(getProfile(profileId))
		return () => {
			if (isAuthenticated) { dispatch(reset()) }
		}
	}, [isAuthenticated, navigate, isError, message, dispatch])



	return (
		<Fragment>


			<div className="row">
				<div className="col-lg-12">
					<div className="profile card card-body px-3 pt-3 pb-0">
						<div className="profile-head">
							<div className="photo-content ">
								<div className="cover-photo rounded"></div>
							</div>
							<div className="profile-info">

									<div className="profile-photo">
										{!safeProfile.thumbnail ? (
											<img
												src={"https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"}
												className="img-fluid rounded-circle"
												alt="profile"
											/>
										) : (
											<img
												src={safeProfile.thumbnail}
												className="img-fluid rounded-circle"
												alt="profile"
											/>
										)}
									</div>

								<div className="profile-details">
									<div className="profile-name px-3 pt-2">
										<h4 className="text-info mb-0">{safeProfile.name} {safeProfile.surName}</h4>
										<p>{safeProfile.job}</p>
									</div>
								

									{/* 
									<Dropdown className="dropdown ms-auto">
										<Dropdown.Toggle
											variant="primary"
											className="btn btn-primary light sharp i-false"
											data-toggle="dropdown"
											aria-expanded="true"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												//    xmlns:xlink="http://www.w3.org/1999/xlink"
												width="18px"
												height="18px"
												viewBox="0 0 24 24"
												version="1.1"
											>
												<g
													stroke="none"
													strokeWidth="1"
													fill="none"
													fillRule="evenodd"
												>
													<rect x="0" y="0" width="24" height="24"></rect>
													<circle fill="#000000" cx="5" cy="12" r="2"></circle>
													<circle fill="#000000" cx="12" cy="12" r="2"></circle>
													<circle fill="#000000" cx="19" cy="12" r="2"></circle>
												</g>
											</svg>
										</Dropdown.Toggle>
										<Dropdown.Menu className="dropdown-menu dropdown-menu-right">
											<Dropdown.Item className="dropdown-item">
												<i className="fa fa-user-circle text-primary me-2" />
												View profile
											</Dropdown.Item>
											<Dropdown.Item className="dropdown-item">
												<i className="fa fa-users text-primary me-2" />
												Add to close friends
											</Dropdown.Item>
											<Dropdown.Item className="dropdown-item">
												<i className="fa fa-plus text-primary me-2" />
												Add to group
											</Dropdown.Item>
											<Dropdown.Item className="dropdown-item">
												<i className="fa fa-ban text-primary me-2" />
												Block
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
									*/}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-xl-4">
					<div className="row">
						<div className="col-lg-12">
							<div className="card">
								<div className="card-body">
									<div className="profile-statistics">
										<div className="text-center">
											<div className="row">
												<div className="col">
													<h3 className="m-b-0">{safeProfile.connections?.length}</h3><span>Bağlantı</span>
												</div>
												<div className="col">
													<h3 className="m-b-0">{safeProfile.meetings?.length}</h3> <span>Toplantı</span>
												</div>
											</div>
											{/* 
											<div className="mt-4">
												<Link to="/post-details" className="btn btn-primary mb-1 me-1">Follow</Link>
												<Button as="a" href="#" className="btn btn-primary mb-1 ms-1" onClick={() => setSendMessage(true)}>Send Message</Button>
											</div>
											*/}
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-8">
					<div className="card">
						<div className="card-header border-0 pb-0">
							<h5 className="text-info">İlgi Alanları</h5>
						</div>
						<div className="card-body pt-3"	>
							<div className="profile-blog ">
								{safeProfile.interests?.map((list, index) => (
									<Link to="/app-profile" className="btn btn-info light btn-xs mb-1 me-1">{list}</Link>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

export default Profile;
